(() => {
async function loadRows(scope = document) {
  for (const target of scope.querySelectorAll('[data-sf-feed]:not([data-loaded])')) {
    target.dataset.loaded = 'true';
    try {
      const response = await fetch(target.dataset.sfFeed, {credentials: 'same-origin'});
      if (!response.ok) throw new Error('Unable to load products');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const feed = html.querySelector('.sf-product-feed');
      if (!feed || !feed.querySelector('.sf-card')) throw new Error('No product cards');
      feed.querySelectorAll('form[id]').forEach(form => {form.id += '-' + target.closest('section').id;});
      target.replaceChildren(feed);
    } catch (error) {
      const link = target.closest('section').querySelector('.sf-section-heading > a').cloneNode(true);
      target.replaceChildren(link);
    } finally { target.setAttribute('aria-busy', 'false'); }
  }
}
loadRows();
document.addEventListener('shopify:section:load', event => loadRows(event.target));
document.addEventListener('keydown', event => {if (event.key === 'Escape') document.querySelectorAll('.sf-mobile-menu[open]').forEach(el => {el.open = false; el.querySelector('summary').focus();});});
document.addEventListener('click', event => {if (!event.target.closest('.sf-mobile-menu')) document.querySelectorAll('.sf-mobile-menu[open]').forEach(el => {el.open = false;});});
document.addEventListener('shopify:cart:lines-update', event => {event.promise?.then(({cart,detail}) => {const count = cart?.totalQuantity ?? detail?.itemCount;if(Number.isInteger(count))document.querySelectorAll('[data-shub-cart-count]').forEach(el => el.textContent = count);}).catch(() => {});});
})();
document.addEventListener('click',e=>{document.querySelectorAll('.sf-nav-group[open]').forEach(d=>{if(!d.contains(e.target))d.open=false;});});document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.sf-nav-group[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});});
